import { Loader2 } from 'lucide-react'

export function LoadingScreen({ label = 'Yükleniyor…' }) {
  return (
    <div className="flex min-h-[45vh] items-center justify-center">
      <div className="flex items-center gap-3 text-sm font-semibold text-brand-navy">
        <Loader2 className="animate-spin" size={20} aria-hidden="true" />
        {label}
      </div>
    </div>
  )
}
